<template>
  <div
    class="app-layout"
    v-loading="loading"
  >
    <el-card
      shadow="never"
    >
      <div slot="header" class="clearfix">
        <span>用户基本信息</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
      </div>
      <div>
        <el-form label-width="120px" size="mini" align="left">
          <el-form-item label="设备名称：" v-if="userInfo.deviceModel">
            {{ userInfo.deviceModel}}
          </el-form-item>
          <el-form-item label="系统版本：" v-if="userInfo.osInfo">
            <!-- {{ userInfo.os }} {{ userInfo.osVersion }} -->
            {{ userInfo.osInfo }}
          </el-form-item>
          <el-form-item label="网络地址：" v-if="userInfo.ip">
            {{ userInfo.ip }}
          </el-form-item>
          <el-form-item label="所在地区：" v-if="userInfo.country">
            {{ userInfo.country }} {{ userInfo.province }} {{ userInfo.city }}
          </el-form-item>
          <el-form-item label="会话id：">
            {{ userInfo.sessionId }}
          </el-form-item>
          <el-form-item label="访客id：">
            {{ userInfo.visitorId }}
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card
      class="margin-top-10"
      shadow="never"
    >
      <div
        slot="header"
        style="display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;"
      >
        <span>
          <!-- eslint-disable-next-line max-len -->
          行为记录列表 <small v-if="$route.query.pageSource === 'server'" style="color: #999">(仅显示最新的100个事件)</small></span>
        <el-row>
          <el-button
            size="mini"
            @click="event.type = null"
            type="primary"
            :plain="!!event.type"
          >全部</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="event.type = -1"
            :plain="event.type !== -1"
          >页面</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="event.type = LogEvent['元素点击']"
            :plain="LogEvent['元素点击'] !== event.type"
          >点击</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="event.type = LogEvent['客户端错误事件']"
            :plain="LogEvent['客户端错误事件'] !== event.type"
          >客户端错误</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="event.type = LogEvent['api请求']"
            :plain="LogEvent['api请求'] !== event.type"
          >api请求</el-button>
        </el-row>
      </div>
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="14" class="padding-right-20">
          <div
            class="padding-right-20"
            style="max-height: 400px; overflow: auto"
            v-if="events.length"
          >
              <el-row
                v-for="(item, index) in events"
                :key="index"
                type="flex"
                class="event-box padding-10 margin-bottom-20 flex-align-center"
                :class="{active: event.activeIndex === index}"
                @click.native="Object.assign(event, {
                  ...item,
                  activeIndex: index,
                })"
              >
                <i
                  class="event-icon"
                  :class="LogEventIcon[LogEvent[item.eventId]]"
                  :style="{
                    color: LogEventColor[LogEvent[item.eventId]],
                    ...(LogEvent[item.eventId] === 'api请求' ? {
                      // eslint-disable-next-line max-len
                      color: item.attr.apiSuccess ? LogEventColor['api请求成功']: LogEventColor['api请求错误']
                    }: null)
                  }"
                ></i>
                <el-col align="left">
                  <p>{{ LogEvent[item.eventId] }}</p>
                  <p class="event-info color-gray font-size-12 margin-top-10">
                    <template v-if="item.attr.uri">
                      {{ item.attr.uri }}
                    </template>
                    <template v-else>
                      {{ item.attr.pageName }}: {{ item.attr.pagePath }}
                    </template>
                  </p>
                </el-col>
                <!-- eslint-disable-next-line max-len -->
                <el-col class="font-size-13" align="right">{{ item.eventTime | formatTime }}</el-col>
              </el-row>
          </div>
          <div v-else style="height: 200px; text-align: center;line-height: 200px">暂无数据</div>
        </el-col>
        <el-col :span="10">
          <el-card
            shadow="never"
            style="min-height: 200px; max-height: 400px; overflow: auto"
          >
            <el-form
              v-if="events.length"
              label-position="top"
              label-width="120px"
              size="mini"
              align="left"
            >
              <el-form-item label="事件类型：">
                <p class="event-info-item">{{ LogEvent[event.eventId] }}</p>
              </el-form-item>
              <el-form-item label="事件发生时间：">
                <p class="event-info-item">
                  {{ event.eventTime | formatTime }}
                </p>
              </el-form-item>
              <el-form-item label="发生页面：" v-if="event.attr.pagePath">
                <p class="event-info-item">{{ event.attr.pageName }}, {{ event.attr.pagePath }}</p>
              </el-form-item>
              <el-form-item label="页面浏览时长" v-if="event.attr.viewDur">
                <p class="event-info-item">{{ (event.attr.viewDur / 1000).toFixed(2) }} 秒</p>
              </el-form-item>
              <el-form-item label="上一级页面：" v-if="event.attr.referrer">
                <p class="event-info-item">{{ event.attr.referrer }}</p>
              </el-form-item>
              <template v-if="LogEvent[event.eventId] === '元素点击'">
                <el-form-item
                  label="按钮名称："
                >
                  <p class="event-info-item">{{ event.attr.btnName }}</p>
                </el-form-item>
                <el-form-item
                  label="属性："
                  v-if="event.attr.btnInfo"
                >
                  <div
                    class="font-size-12 event-info-item"
                    style="background: #f9fafd;padding: 10px;"
                  >
                    <p
                      v-for="(item, index) in event.attr.btnInfo.attributes"
                      :key="'attributes' + index"
                    >
                      <b>{{ item.nodeName }}</b>{{ item.nodeValue ? '：' : '' }}{{ item.nodeValue }}
                    </p>
                  </div>
                </el-form-item>
                <el-form-item
                  label="outerHTML："
                  v-if="event.attr.btnInfo"
                >
                  <div class="event-info-item" style="background: #f9fafd;padding: 10px;">
                    <div>
                      {{ event.attr.btnInfo.outerHTML }}
                    </div>
                     <el-divider content-position="left">element-UI</el-divider>
                    <div
                      style="position: relative; padding: 20px 10px;"
                    >
                      <div v-html="event.attr.btnInfo.outerHTML" />
                    </div>
                  </div>
                </el-form-item>
              </template>
              <el-collapse v-model="activeCollapseNames" v-if="event.attr.storageInfo">
                <el-collapse-item title="应用本地缓存：" name="storage">
                  <div
                    style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                  >
                    <div
                      class="font-size-12"
                      v-for="(value, key, index) in event.attr.storageInfo"
                      :key="'storageInfo' + index"
                    >
                      <template v-if="key !== 'data'" >
                        <b>{{ key }}</b>：{{ value }}
                      </template>
                      <template v-else-if="event.attr.storageInfo.data">
                        <div><b>{{ key }}</b>：
                          <div
                            class="font-size-12 padding-left-10"
                            v-for="(childValue, childKey, child) in event.attr.storageInfo.data"
                            :key="'storageInfo_data' + child"
                          >
                            <b>{{ childKey }}</b>：{{ childValue }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <template v-if="LogEvent[event.eventId] === '客户端错误事件'">
                <el-form-item label="错误类型：">
                  <p class="event-info-item">{{ event.attr.errorType }}</p>
                </el-form-item>
                <el-form-item label="错误信息：">
                  <p class="event-info-item">{{ event.attr.errorMessage }}</p>
                </el-form-item>
                <el-collapse v-model="activeCollapseNames">
                  <el-collapse-item title="错误堆栈信息：" name="errorStack">
                    <div :style="{ 'text-align': 'right' }">
                      <el-button
                        type="text"
                        size="mini"
                        @click="handleGetSourceCode(event.attr)"
                      >获取错误源码</el-button>
                    </div>
                    <div
                      style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                      v-html="
                        event.attr.errorStack
                        .replace(/↵/g, '<br />').replace(/n(\s){1,}at/g, '<br /> at')"
                    />
                  </el-collapse-item>
                </el-collapse>
              </template>
              <template v-if="LogEvent[event.eventId] === 'api请求'">
                <el-form-item label="api地址：">
                  <p class="event-info-item">{{ event.attr.uri }}</p>
                </el-form-item>
                <el-form-item label="请求方式：">
                  <p class="event-info-item">
                    {{ event.attr.httpMethod }}
                  </p>
                </el-form-item>
                <el-form-item label="请求状态编码：">
                  <p
                    class="event-info-item"
                    :class="[event.attr.apiSuccess ? 'color-green' : 'color-red']"
                  >{{ event.attr.apiCode }} {{ event.attr.apiMessage }}</p>
                </el-form-item>
                <el-form-item label="请求开始时间：">
                  <p class="event-info-item">{{ event.attr.start | formatTime }}</p>
                </el-form-item>
                <el-form-item label="响应时长：">
                  <p class="event-info-item">{{ (event.attr.cost / 1000).toFixed(2) }} 秒</p>
                </el-form-item>
                <el-form-item label="链路id：">
                  <p class="event-info-item">{{ event.attr.traceId }}</p>
                </el-form-item>
                <el-collapse v-model="activeCollapseNames">
                  <el-collapse-item title="头部数据：" name="headers">
                    <div
                      style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                    >
                      <p
                        class="font-size-12"
                        v-for="(value, key, index) in event.attr.headers"
                        :key="'headers' + index"
                      ><b>{{ key }}</b>：{{ value[0] }}</p>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="请求数据：" name="requestBody">
                    <el-card
                      class="margin-bottom-15"
                      shadow="never"
                    >
                      <div slot="header" style="width: 100%">
                        <el-row type="flex" class="flex-align-center flex-justify-between">
                          <span>query</span>
                          <el-button
                            v-if="event.attr.query"
                            size="mini"
                            type="primary"
                            @click="requestType = 1 - requestType"
                          >{{requestType === 1 ? 'string' : 'json'}}</el-button>
                        </el-row>
                      </div>
                      <template v-if="event.attr.query">
                        <jsonView
                          v-if="requestType === 1" :data="parseUrlObject(event.attr.query)"
                        />
                        <div
                          style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                          v-else
                        >
                          {{ event.attr.query }}
                        </div>
                      </template>
                      <div
                        style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                        v-else
                      >
                      暂无数据
                      </div>
                    </el-card>
                    <el-card
                      class="margin-bottom-15"
                      shadow="never"
                    >
                      <div slot="header" style="width: 100%">
                        <el-row type="flex" class="flex-align-center flex-justify-between">
                          <span>requestBody</span>
                          <el-button
                            v-if="event.attr.requestBody"
                            size="mini"
                            type="primary"
                            @click="requestType = 1 - requestType"
                          >{{requestType === 1 ? 'string' : 'json'}}</el-button>
                        </el-row>
                      </div>
                      <template v-if="event.attr.requestBody">
                        <jsonView
                          v-if="requestType === 1"
                          :data="JSONbigString.parse(event.attr.requestBody)"
                        />
                        <div
                          style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                          v-else
                        >
                          {{ requestBody }}
                        </div>
                      </template>
                      <div
                        style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                        v-else
                      >
                      暂无数据
                      </div>
                    </el-card>
                  </el-collapse-item>
                  <el-collapse-item title="响应数据：" name="responseBody">
                    <template v-if="event.attr.responseBody">
                      <div class="align-right padding-bottom-10">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          @click="responeType = 1 - responeType"
                        >{{responeType === 1 ? 'string' : 'json'}}</el-button>
                      </div>
                      <jsonView
                        v-if="responeType === 1"
                        :data="JSONbigString.parse(event.attr.responseBody)"
                      />
                      <div
                        style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                        v-else
                      >
                        {{ event.attr.responseBody }}
                      </div>
                    </template>
                    <div
                      style="padding: 10px;background: #f9fafd;word-wrap: break-word;"
                      v-else
                    >
                    暂无数据
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </template>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-card>

    <source-code v-model="codeDialogVisible" :stack="stack" />

  </div>
</template>

<script>
import jsonView from 'vue-json-views';
// eslint-disable-next-line import/no-unresolved
import JSONbig from 'json-bigint';
import {
  mapGetters,
} from 'vuex';
import {
  querySessionBehavior,
} from '@/api/log/index';
import {
  LogEvent,
  LogEventIcon,
  LogEventColor,
} from '@/data/log';
import { stackParse } from '@/utils/source-code';
import SourceCode from '@/components/source-code/index.vue';
import { getStackParseCode } from '@/api/report/index';

export default {
  name: 'ApplicationAnalysisErrorReport',
  components: { jsonView, SourceCode },
  data() {
    return {
      JSONbigString: JSONbig({ storeAsString: true }),
      loading: false,
      activeCollapseNames: null,
      LogEvent,
      LogEventIcon,
      LogEventColor,
      originEvents: [],
      requestType: 1,
      responeType: 1,
      event: {
        activeIndex: 0,
        attr: {},
        type: null, // LogEvent[]
      },
      userInfo: {
        apiCost: '',
        city: '',
        country: '',
        deviceModel: '',
        ip: '',
        os: '',
        osVersion: '',
        osInfo: '',
        province: '',
        sessionId: '',
        visitorId: '',
      },
      stack: [],
      codeDialogVisible: false,
    };
  },
  mounted() {},
  computed: {
    events() {
      const { type } = this.event;
      // eslint-disable-next-line vue/no-async-in-computed-properties
      this.$nextTick(() => {
        this.renderEvent();
      });
      return this.originEvents.filter((item) => {
        if (type === -1) {
          return item.eventId !== LogEvent['api请求'] && item.eventId !== LogEvent['客户端错误事件'] && item.eventId !== LogEvent['元素点击'];
        }
        if (!type) {
          return true;
        }
        return item.eventId === type;
      });
    },
    ...mapGetters('app', [
      'source',
      'env',
      'serverName',
    ]),
  },
  watch: {
    'event.type': {
      handler() {
        this.search();
      },
    },
    source: {
      handler() {
        this.search();
      },
      immediate: true,
    },
    serverName: {
      handler() {
        this.search();
      },
      immediate: true,
    },
    env: {
      handler() {
        this.search();
      },
    },
  },
  methods: {
    async handleGetSourceCode(attr) {
      try {
        const { errorStack, app, appVersion } = attr;
        if (!errorStack || !app || !appVersion) {
          this.$message.error('无查找到指定版本的源码');
          return;
        }
        this.loading = true;
        const { data } = await getStackParseCode({
          stack: errorStack,
          app,
          appVersion,
        });
        this.stack = stackParse(data);
        this.codeDialogVisible = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    parseUrlObject(paramsStr) {
      const params = decodeURIComponent(paramsStr);
      const obj = {};
      const keyValue = params.split('&');
      for (let i = 0; i < keyValue.length; i += 1) {
        const item = keyValue[i].split('=');
        const key = item[0];
        const value = item[1];
        obj[key] = value;
      }
      return obj;
    },
    async search() {
      try {
        this.loading = true;
        const {
          env,
          source,
          $route: {
            query: {
              to: analyzeTimeTo,
              sessionId,
            },
          },
          event: {
            type,
          },
        } = this;

        const params = {
          source,
          env,
          sessionId,
          analyzeTimeFrom: `${analyzeTimeTo} 00:00:00`,
          analyzeTimeTo: `${analyzeTimeTo} 23:59:59`,
          eventId: LogEvent[type] ? type : '',
        };

        const { pageSource, form, to } = this.$route.query;
        if (form && to) {
          params.analyzeTimeFrom = form;
          params.analyzeTimeTo = to;
        }

        if (pageSource === 'server') {
          params.serverName = this.serverName;
          delete params.source;
        }

        const {
          data: {
            apiCost = '',
            city,
            country,
            deviceModel,
            events,
            ip,
            os,
            osVersion,
            osInfo,
            province,
            visitorId,
          } = {},
        } = await querySessionBehavior(params);

        Object.assign(this.userInfo, {
          apiCost,
          city,
          country,
          deviceModel,
          ip,
          os,
          osVersion,
          osInfo,
          province,
          visitorId,
          sessionId,
        });
        this.originEvents.splice(0);
        this.originEvents.push(...events);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    renderEvent() {
      Object.assign(this.event, {
        ...this.events[0],
        activeIndex: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.color-green {
  color: #00af56;
}
.color-red {
  color: #f85149;
}
.color-gray {
  color: #a3a5b0;
}
.user-chart-box {
  height: 200px;
}
.small-chart-box {
  height: 220px;
}
.radius-rad {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e67482;
}
.txt-bule {
  color: #1890ff;
}
.txt-gray {
  color: #666;
}
.app-layout {
  min-width: 928px;
  padding: 15px 15px;
  min-height: calc(100vh - 0);
}
.table-wrap {
  position: relative;
}
.table-wrap-date {
  position: absolute;
  right: 0;
  top: 10px;
  color: #5d5cb6;
  font-weight: bold;
}
.event-box {
  margin-left: 40px;
  position: relative;
  border-radius: 8px;
  background: #f7f7f7;
  cursor: pointer;
  &.active {
    background: #fff4ee;
  }
  &::before {
    display: block;
    content: '';
    position: absolute;
    left: -30px;
    top: 45px;
    bottom: -10px;
    width: 2px;
    background: #e8e8e8;
  }
}
.event-icon {
  position: absolute;
  font-size: 25px;
  left: -40px;
  top: 10px;
}
.event-info-item {
  margin-top: -15px;
  margin-bottom: -10px;
  font-size: 12px;
  line-height: 16px;
  word-break: break-all;
}
.event-info {
  word-break: break-all;
}
</style>
